/* eslint-disable jsx-a11y/anchor-is-valid */
import { ApiMutualFundAssetRead, ApiSegregatedPortfolioAssetRead } from 'api/rtk-api'
import { useState } from 'react'

import { LinkButton, MessageBox } from '../../atoms'
import Icon from '../../atoms/Icon'
import { Space } from '../../atoms/space/index'
import IconButton from '../../molecules/iconButton'
import LinkIcon from '../../molecules/linkIcon'
import { AssetLookup } from '../asset-lookup'
import { SimpleModal } from '../simple-modal'
import { StyledAssetTable } from './primitives'

export type ProtectionAssetSelectorProps = {
  asset?: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  assets: (ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead)[]
  onInspectAsset
  onSelectAsset
}

const AssetSelectedView = ({
  asset,
  onInspectAsset,
  onRequestToChooseAsset
}: {
  asset: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead
  onInspectAsset: (assetId: ApiMutualFundAssetRead | ApiSegregatedPortfolioAssetRead) => void
  onRequestToChooseAsset: () => void
}) => (
  <>
    <Space mb={6}>
      <StyledAssetTable>
        <thead>
          <tr>
            <th className="asset">Protection asset</th>
            <th className="weight">Weight (%)</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="asset">
              <LinkButton
                underline
                onClick={() => {
                  onInspectAsset(asset)
                }}
              >
                {asset.name}
              </LinkButton>
            </td>

            <td className="weight">100%</td>
          </tr>
        </tbody>
      </StyledAssetTable>
    </Space>
    <Space isflex justifyContent="center">
      <LinkIcon
        disabled={false}
        icon={<Icon name="search" size="default" />}
        iconPosition="left"
        text="Choose another protection asset"
        onClick={() => onRequestToChooseAsset()}
      />
    </Space>
  </>
)

const AssetUnselectedView = ({
  onRequestToChooseAsset
}: {
  onRequestToChooseAsset: () => void
}) => (
  <Space isflex justifyContent="center">
    <IconButton
      data-testid="add-protection-asset-button"
      disabled={false}
      icon={<Icon name="circleAdd" size="default" />}
      iconPosition="left"
      operationType="progress"
      text="Add a protection asset"
      width="100%"
      onClick={() => onRequestToChooseAsset()}
    />
  </Space>
)

export function ProtectionAssetSelector({
  asset,
  assets,
  onInspectAsset,
  onSelectAsset
}: ProtectionAssetSelectorProps) {
  const [isChoosing, setIsChoosing] = useState(false)

  return (
    <>
      {isChoosing && (
        <SimpleModal>
          <AssetLookup
            assets={assets}
            onClickClose={() => setIsChoosing(false)}
            onSelectAsset={asset => {
              onSelectAsset(asset)
              setIsChoosing(false)
            }}
          />
        </SimpleModal>
      )}
      {asset && (
        <AssetSelectedView
          asset={asset}
          onInspectAsset={onInspectAsset}
          onRequestToChooseAsset={() => setIsChoosing(true)}
        />
      )}
      {!asset && (
        <>
          <AssetUnselectedView onRequestToChooseAsset={() => setIsChoosing(true)} />
          <Space my={5}>
            <MessageBox state="warning">You have to select a protection asset</MessageBox>
          </Space>
        </>
      )}
    </>
  )
}
